import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './individual-meter-water-meter-cold-lg.svg';
import md from './individual-meter-water-meter-cold-md.svg';
import sm from './individual-meter-water-meter-cold-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.INDIVIDUAL_METER_WATER_METER_COLD,
  label: 'Individueller_Kaltwasserzähler',
  shortLabel: 'INDKW',
  icons: { sm, md, lg },
  component: component('individual-meter-water-meter-cold/IndividualMeterColdWaterMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('individual-meter-water-meter-cold/IndividualMeterColdWaterMeterAggregationWidget.vue'),
    props: { digitColor: 'BLUE' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
